export default __webpack_public_path__ + "static/media/img47.afa0d44c.jpg";